import React, { useState, useEffect, useRef } from 'react';
import '../styles/global.css';
import logo from '../assets/logoSF.png';
import { Link } from 'react-router-dom';
import { LabelImportant } from '@mui/icons-material';
import { useParams, useNavigate } from 'react-router-dom';

const Header = () => {
    const [menuAberto, setMenuAberto] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const headerRef = useRef(null);
const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuAberto(!menuAberto);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header>
        <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} ref={headerRef}>
            <div className="nav-logo">
            <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className='divLabelHeader'>
            <label className='labelHeader' >TAX LOW PRICES</label>
        </div>
      <div className={`nav-links ${menuAberto ? 'aberto' : ''}`} ref={headerRef}>
        <div>
          <Link to="/" onClick={toggleMenu}>Home</Link>
        </div>
        <div>
          <Link to="/About" onClick={toggleMenu}>About</Link>
        </div>
        <div>
          <Link to="/Services" onClick={toggleMenu}>Services & Prices</Link>
        </div>
        <div>
          <Link to="/Contact" onClick={toggleMenu}>Contact</Link>
        </div>
        <div>
          { sessionStorage.getItem('IdTaxPayer') && parseInt(sessionStorage.getItem('IdTaxPayer')) > 0 ? (
            <Link style={{ border: '1px solid #fff', padding: '5px', borderRadius: '5px' }} to={`/TaxPayer/${sessionStorage.getItem('txpCodeGUID')}`} onClick={toggleMenu}>My Account</Link>
          ) : (
            <Link style={{ border: '1px solid #fff', padding: '5px', borderRadius: '5px' }} to="/Access" onClick={toggleMenu}>Sign in</Link>
          )}
        </div>
        <div>
        { sessionStorage.getItem('IdTaxPayer') && parseInt(sessionStorage.getItem('IdTaxPayer')) > 0 ? (
              <label style={{ border: '1px solid #fff', padding: '5px', borderRadius: '5px', backgroundColor: 'transparent', color: '#fff' }} 
              onClick={() => {
                sessionStorage.removeItem('IdTaxPayer');
                sessionStorage.removeItem('txpCodeGUID');
                toggleMenu();
                 navigate('/');
              }}>Logout</label>
          ) : null 
          }
          </div>
      </div>
      <div>
          <button className="menu-toggle" style={{ textDecoration: 'none' }} onClick={toggleMenu}>
            <img src={logo} alt="Logo" className="logoMenu" style={{ textDecoration: 'none' }}  />
          </button>
          <span className='text-align-right LnkMenu'>MENU</span>
        </div>
      </nav>
    </header>
  );
}

export default Header;